/**
 * BigInt polyfill for older browsers (Safari < 14)
 * This polyfill provides basic BigInt support needed by zod library
 */

if (typeof BigInt === 'undefined') {
  // @ts-expect-error - Polyfill for BigInt
  globalThis.BigInt = function BigIntPolyfill(value: number | string) {
    // Convert to number for basic operations
    const num = typeof value === 'string' ? Number.parseFloat(value) : value;

    // Create a BigInt-like object that can be used with basic operations
    const bigIntObj = {
      valueOf: () => num,
      toString: () => String(num),
      // Add basic comparison support
      [Symbol.toPrimitive]: (hint: string) => {
        if (hint === 'number') return num;
        if (hint === 'string') return String(num);
        return num;
      },
    };

    return bigIntObj as unknown as bigint;
  };

  // Add BigInt constructor properties
  globalThis.BigInt.asIntN = (_bits: number, value: bigint) => value;
  globalThis.BigInt.asUintN = (_bits: number, value: bigint) => value;
}
